import { useState } from 'react';
import {
  Alert, Button, IconButton, Menu, MenuItem, ListItemIcon, ListItemText, Stack, Tooltip,
} from '@mui/material';
import { Add, MoreVert } from '@mui/icons-material';
import PageShell from '../../components/layout/PageShell';
import PageHeader from '../../components/layout/PageHeader';
import PartnerSubscriptionPlanManager from '../../components/partners/PartnerSubscriptionPlanManager';
import { PARTNER_PLAN_ALERT_SX, PARTNER_PLAN_NOTE_SX } from '../../constants/partnerSubscriptionPlanConfig';

export default function PartnerSubscriptionPlansPage() {
  const [addPlanRequest, setAddPlanRequest] = useState(0);
  const [headerMenuAnchor, setHeaderMenuAnchor] = useState<null | HTMLElement>(null);

  const openCreate = () => {
    setAddPlanRequest((n) => n + 1);
    setHeaderMenuAnchor(null);
  };

  return (
    <PageShell>
      <PageHeader
        eyebrow="Onboarding"
        title="Partner Subscription Plans"
        subtitle="Tenant-scoped prepaid plans for drivers and delivery partners — separate from platform tenant SaaS billing."
        subtitleSx={PARTNER_PLAN_NOTE_SX}
        actions={(
          <Stack direction="row" spacing={0.5} alignItems="center">
            <Tooltip title="More actions">
              <IconButton
                aria-label="Subscription plan menu"
                onClick={(e) => setHeaderMenuAnchor(e.currentTarget)}
              >
                <MoreVert />
              </IconButton>
            </Tooltip>
            <Button variant="contained" startIcon={<Add />} onClick={openCreate}>
              Add plan
            </Button>
          </Stack>
        )}
      />
      <Menu
        anchorEl={headerMenuAnchor}
        open={!!headerMenuAnchor}
        onClose={() => setHeaderMenuAnchor(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem onClick={openCreate}>
          <ListItemIcon><Add fontSize="small" /></ListItemIcon>
          <ListItemText>Add subscription plan</ListItemText>
        </MenuItem>
      </Menu>
      <Alert severity="info" sx={{ mb: 2, ...PARTNER_PLAN_ALERT_SX }}>
        Plans with active partners cannot be deleted — deactivate instead. Existing partners keep their plan; new registrations will not see inactive plans.
      </Alert>
      <PartnerSubscriptionPlanManager showHeader={false} addPlanRequestId={addPlanRequest} />
    </PageShell>
  );
}
